import React, { FunctionComponent } from 'react';

import { P } from '@savebetter/components';

export const PageSectionDescription: FunctionComponent<React.PropsWithChildren<unknown>> = ({ children }) => (
  <P className="lg:sb-page-description mx-auto text-left lg:text-center pb-14">{children}</P>
);
